//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import tributaryLinkTemplate from '@legacy-components/common/universal-image-actions/tributary-link.html';

(function() {
  const uia = angular.module('uia');
  uia.component('tributaryLink', {
    bindings: {
      startingInstance: '<',
      index: '<',
      impl: '<',
      shortenLink: '<',
      startingParamsString: '<',
      curalateParamKey: '<',
      isContextualShowroom: '<',
    },
    template: tributaryLinkTemplate,
    controller: [
      '$element',
      '$timeout',
      '$scope',
      '$window',
      'ShowroomApiService',
      'ShowroomService',
      function(
                $element,
                $timeout,
                $scope,
                $window,
                ShowroomApiService,
                ShowroomService,
            ) {
        this.urlToShow = '';
        this.instance = undefined;
        this.shortLinkOutstandingAsync = undefined;

        const TRACKING_PARAM_DROPDOWN_PREDEFINED_SORT_ORDER = {
          utm_source: 1,
          utm_medium: 2,
          utm_campaign: 3,
          utm_content: 4,
          utm_term: 5,
        };

        this.trackingParamOverrideValue = '';
        this.trackingParamDropdown = {
          selectedName: null,
          nameOptions: [],
        };

        const setTrackingParamOverrideValue = () => {
          this.trackingParamOverrideValue = this.instance.instanceTrackingParameters[this.trackingParamDropdown.selectedName] ||
                        ShowroomService.getDefaultTrackingParameterValue();
        };

        const setupTrackingParamDropdown = () => {
          const names = _.keys(this.instance.instanceTrackingParameters);
          const selectedName = angular.copy(this.instance.trackingParamOverrideName);
          if (names.indexOf(selectedName) < 0) {
            names.push(selectedName);
          }

                    // Sort the names such that the utm_parameters come first and are in natural order
          const predefinedSortOrderValues = _.values(TRACKING_PARAM_DROPDOWN_PREDEFINED_SORT_ORDER);
          const maxPredefinedSortOrder = _(predefinedSortOrderValues).max() + 1;
          const namesSorted = _(names).sortBy((name) => {
            return TRACKING_PARAM_DROPDOWN_PREDEFINED_SORT_ORDER[name] || maxPredefinedSortOrder;
          });

          _(namesSorted).each((name) => {
            this.trackingParamDropdown.nameOptions.push({ name, value: name });
          });

          this.trackingParamDropdown.selectedName = selectedName;
          this.trackingParamOverrideValue = angular.copy(this.instance.trackingParamOverrideValue);
        };

        this.changeTrackingParamOption = function(value) {
          if (this.trackingParamDropdown.selectedName !== value) {
            this.trackingParamDropdown.selectedName = value;
            setTrackingParamOverrideValue();
            this.onTrackingParamOverrideValueChanged();
          }
        };

        $scope.$on('copy-button:copied', (e) => {
          e.stopPropagation();
        });

        const updateShortenedLink = () => {
          if (this.shortenLink) {
            if (!_.isUndefined(this.instance.shortLink)) {
              this.urlToShow = this.instance.shortLink;
            } else {
              this.shortLinkOutstandingAsync = 'getTribShortLink';
              ShowroomApiService.getTributaryImplShortLinkAsync(
                                this.impl.id,
                                this.impl.name,
                                this.impl.sourceId,
                                'item', // From the UIA, only item sourceTypes are supported
                                this.instance.instanceId,
                            ).then((result) => {
                              if (result.shortLink) {
                                this.instance.shortLink = result.shortLink;
                                this.urlToShow = this.instance.shortLink;
                              } else {
                                    // TODO Pop an error or something
                              }
                            }).finally(() => {
                              this.shortLinkOutstandingAsync = null;
                            });
            }
          } else {
            this.urlToShow = this.instance.longLink;
          }
        };

        this.onTrackingParamOverrideValueChanged = () => {
          ShowroomService.updateInstanceTrackingParamOverride(
                        this.instance.instanceId,
                        this.trackingParamDropdown.selectedName,
                        this.trackingParamOverrideValue,
                    );
        };

        this.selectAllTextbox = (id) => {
          $element.find(`#${id}`).focus().select();
        };

        this.$onChanges = (changesObj) => {
          if (!_.isUndefined(changesObj.shortenLink) &&
                        changesObj.shortenLink.currentValue !== changesObj.shortenLink.previousValue &&
                        !changesObj.shortenLink.isFirstChange()
                    ) {
            updateShortenedLink();
          }
        };

        this.$onInit = () => {
          this.trackingCategory = ShowroomService.getTrackingCategory();
          this.trackingAction = ShowroomService.getTrackingAction();
          this.trackingLabels = {
            copyLink: () => { return `CopyLink=${(this.shortenLink) ? 'Short' : 'Full'}`; },
          };

          this.instance = angular.copy(this.startingInstance);
                    // TODO: Sort out how to get "focus to select-all" to work...
                    // $element.find('.tributary-link-text-container').focus(function() {
                    //     const elem = angular.element(this);
                    //     elem.select();
                    //     elem.mouseup(() => {
                    //         elem.unbind('mouseup');
                    //         return false;
                    //     });
                    // });

          updateShortenedLink();
          setupTrackingParamDropdown();
          setTrackingParamOverrideValue();
        };
      },
    ],
  });
})();
